import React from "react";
import { useNavigate } from "react-router-dom";
import Nav from "components/layout/Nav";
import { MenuBar } from "components/layout/MenuBar";
import { Helmet } from "react-helmet";
import { cmsSegments } from "constants/cmsSegments";
import { useSelector } from "react-redux";
import { projectSegmentsForUser } from "utils/accessControl";

const CMSHome = () => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);
    // For district managers/editors, hide segments they can't access; super admins still see all
    const shouldHideBlocked = !(user?.isSuperAdmin || user?.role === "superAdmin");
    const segmentsForUser = projectSegmentsForUser(cmsSegments, user, { hideBlocked: shouldHideBlocked });
    const hasAnyAccess = segmentsForUser.length > 0;

    const navigateToCMS = (segment) => {
        if (segment?.disabled) {
            return;
        }

        if (segment?.directRoute) {
            navigate(segment.link);
            return;
        }

        navigate(`${segment.link}/all-locations`);
    };

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Content Management Panel</title>
            </Helmet>
            <Nav />
            <div className="row cmsHomeLayout">
                <MenuBar />
                <main className="cmsHomeMain">
                    <div className="cmsSegmentGrid">
                        {!hasAnyAccess && (
                            <p style={{ gridColumn: "1 / -1", color: "#ff5151" }}>
                                You don't have any segment access yet. Please contact a Super Admin to assign segments or locations.
                            </p>
                        )}
                        {segmentsForUser.map((data, index) => (
                            <div
                                key={index}
                                className={`segmentCard card ${data.disabled ? "disabled" : ""}`}
                                onClick={() => navigateToCMS(data)}
                                style={{
                                    cursor: data.disabled ? "not-allowed" : "pointer",
                                    backgroundColor: data.disabled ? "#eef0f3" : "white",
                                    color: data.disabled ? "#7a7a7a" : "black",
                                    opacity: data.disabled ? 0.6 : 1,
                                }}
                            >
                                {data.icon}
                                <h5 style={{ marginTop: "10px" }}>{data.title}</h5>
                            </div>
                        ))}
                    </div>
                </main>
            </div>
        </>
    );
};

export default CMSHome;
